import React, { useMemo, useState } from 'react'
import { View } from 'styles/reactnative'
import { Upload, Spin } from 'antd'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import { beforeUpload } from 'utils/ExpensiveFunction'
import { useWindowDimensions } from 'app/hooks'

const EventUpdateImage = ({ apiImages, setApiImages, images, setImages }) => {
	const { width } = useWindowDimensions()
	const [loading, setLoading] = useState(false)
	const onChange: UploadProps['onChange'] = (info: any) => {
		const newFileList = info.fileList.filter((file: UploadFile) => {
			const exists = images.some(
				(image: UploadFile) =>
					image.uid === file.uid && !image.name && image.url
			)
			return !exists
		})
		setLoading(true)
		setTimeout(() => {
			setLoading(false)
		}, 1500)
		setImages(newFileList)
	}
	const fileList = useMemo(
		() =>
			[...apiImages.map(url => ({ url })), ...images].filter(
				(file, index, arr) => {
					if (file.url) {
						return index === arr.findIndex(f => f.url === file.url)
					}
					return true
				}
			),
		[apiImages, images]
	)

	const onPreview = async (file: UploadFile) => {
		let src = file.url as string
		if (!src) {
			src = await new Promise(resolve => {
				const reader = new FileReader()
				reader.readAsDataURL(file.originFileObj as RcFile)
				reader.onload = () => resolve(reader.result as string)
			})
		}
		const image = new Image()
		image.src = src
		const imgWindow = window.open(src)
		imgWindow?.document.write(image.outerHTML)
	}
	const onRemove = (file: UploadFile) => {
		const newFileList = fileList.filter(f => f.uid !== file.uid)
		setImages(newFileList)

		if (file.url && apiImages?.length) {
			const newApiImages = apiImages.filter(url => url !== file.url)
			setApiImages(newApiImages)
		}
	}

	return (
		<View
			style={{
				width: '100%',
				padding: 3,
				marginTop: width < 600 ? 150 : 30,
				marginBottom: 30,
			}}>
			<Spin delay={300} spinning={loading} tip="Loading" size="large">
				<Upload
					name="avatar"
					listType="picture-card"
					className="avatar-uploader"
					fileList={fileList}
					onChange={onChange}
					beforeUpload={beforeUpload}
					onPreview={onPreview}
					multiple={true}
					onRemove={onRemove}>
					Upload
				</Upload>
			</Spin>
		</View>
	)
}

export default React.memo(EventUpdateImage)
